import type { OrdersListParams } from '@/admin/api/orders';
import { ordersApi } from '@/admin/api/orders';
import { keepPreviousData, queryOptions } from '@tanstack/react-query';

export type { OrdersListParams };

export const ordersQuery = (params?: OrdersListParams) =>
	queryOptions({
		queryKey: ['orders', params ?? {}] as const,
		queryFn: () =>
			ordersApi.list({
				...params,
				context: 'edit',
			}),
		placeholderData: keepPreviousData,
		staleTime: 30_000,
	});
